import React, { useRef, useState } from 'react';
import './style.css';
import { useNavigate } from 'react-router-dom';
import { LoginFormData } from './types';
import { QRCode } from 'react-qrcode-logo';
import logoAnga from '../../../assets/images/logo-anga.png';
import logoNexus from '../../../assets/images/image.png';
import iconNexus from '../../../assets/images/logo-sem-anga.png';
import ToastNotification from '../../../components/toast_notification';
import { Modal, Form, Button } from 'react-bootstrap';
import { FaCircleNotch } from 'react-icons/fa';
import { useAuthContext } from '../../../contexts/AuthContext';
import { API_CONFIG } from '../../../config/api';

const cds = {
  "fundo": {
    "cubeQuery": {
      "timeDimensions": [],
      "dimensions": [
        "fundo.id",
        "fundo.nome_fantasia"
      ]
    }
  },
  "empresa": {
    "cubeQuery": {
      "timeDimensions": [],
      "dimensions": [
        "empresa.id",
        "empresa.nome_fantasia",
      ],
      "filters": [
        {
          "values": [
            "true"
          ],
          "member": "empresa.is_ativo",
          "operator": "equals"
        }
      ]
    }
  }
}

const Login = () => {
  const navigate = useNavigate();
  const [otpUri, setOtpUri] = useState<string | null>(null);
  const [otpCode, setOtpCode] = useState<string[]>(Array(6).fill(''));
  const otpRefs = useRef<(HTMLInputElement | null)[]>([]);
  const [requireOtpCode, setRequireOtpCode] = useState(false);
  const [emailError, setEmailError] = useState(false);
  const [passwordError, setPasswordError] = useState(false);
  const [showModalRecoveryPass, setshowModalRecoveryPass] = useState(false);
  const { setPermissions } = useAuthContext();

  const [formData, setFormData] = useState<LoginFormData>({
    email: '',
    password: '',
  });

  const [toast, setToast] = useState<{ show: boolean, message: string, status?: number }>({
    show: false,
    message: '',
    status: 500
  });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleVerifyCode = async () => {
    if (!otpCode || otpCode.length < 6) {
      setToast({ show: true, message: "Informe o código de autenticação", status: 400 });
      return;
    }

    setLoadingVerifyCode(true);
    try {
      const response = await fetch(`${API_CONFIG.AUTH_URL}/login`, {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          email: formData.email,
          senha: formData.password,
          codigo: otpCode.join('')
        })
      });

      const data = await response.json();

      if (response.ok) {
        setPermissions(data.permissoes);

        setTimeout(() => {
          navigate("/");
          const idUsuario = data.usuario;
          const is_admin = data.is_admin;
          const nome = data.nome_usuario;
          const sobrenome = data.sobrenome_usuario;
          const email = data.email;

          localStorage.setItem("id_usuario", idUsuario);
          localStorage.setItem("is_admin", is_admin);
          localStorage.setItem("nome", nome);
          localStorage.setItem("sobrenome", sobrenome);
          localStorage.setItem("email", email);
          setLoadingVerifyCode(false);
          localStorage.setItem("ScreenDataModels", JSON.stringify(cds));
        }, 100);
      } else {
        setToast({ show: true, message: data.message || "Código ou senha inválidos.", status: 400 });
        setLoadingVerifyCode(false);
      }
    } catch (err) {
      setToast({ show: true, message: "Erro ao verificar o código.", status: 500 });
      console.error(err);
      setLoadingVerifyCode(false);
    }
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (loadingLogin) return;
    
    const emailRegex = /^[^\s@]+@[^\s@]+\.(com|br|com\.br)$/i;

    setLoadingLogin(true);
    setEmailError(false);
    setPasswordError(false);

    if (!formData.email || !formData.password) {
      if (!formData.email) setEmailError(true);
      if (!formData.password) setPasswordError(true);
      setToast({ show: true, message: "Preencha todos os campos obrigatórios", status: 400 });
      setLoadingLogin(false);
      return;
    }

    if (!emailRegex.test(formData.email)) {
      setEmailError(true);
      setToast({ show: true, message: "E-mail inválido", status: 400 });
      setLoadingLogin(false);
      return;
    }

    try {
      const response = await fetch(`${API_CONFIG.AUTH_URL}/login`, {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          email: formData.email,
          senha: formData.password
        })
      });

      const data = await response.json();

      switch (response.status) {
        case 200:
          if (data.uri) {
            setOtpUri(data.uri);
          } else {
            setOtpUri(null);
          }
          setRequireOtpCode(true);
          break;

        case 401:
          setToast({ show: true, message: data.message || "Usuário ou senha incorretos", status: 401 });
          break;

        case 500:
          setToast({ show: true, message: data.message || "Erro interno no servidor", status: 500 });
          break;

        default:
          setToast({ show: true, message: data.message || "Erro desconhecido", status: response.status });
          break;
      }
    } catch (error) {
      console.error("Erro na requisição:", error);
      setToast({
        show: true,
        message: "Erro interno na comunicação com o servidor, tente novamente e caso o erro persista entre em contato com o suporte.",
        status: 500
      });
    } finally {
      setLoadingLogin(false);
    }

  };

  const [email, setEmail] = useState('');

  const handleSend = () => {
    setLoadingRecovery(true);
    if (email.trim() !== '') {
      fetch(`${API_CONFIG.BASE_URL}/cadastros/usuarios/redefinir-senha/solicitar`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          email: email
        })
      }).then((response) => {
        setToast({ show: true, message: "E-mail enviado com sucesso!", status: 200 });
        setshowModalRecoveryPass(false)
        setEmail("");
        setLoadingRecovery(false)
      }).catch((error) => {
        setToast({ show: true, message: "Verfique o e-mail informado e tente novamente.", status: 500 });
        setshowModalRecoveryPass(false)
        setEmail("");
        setLoadingRecovery(false)
      });
    }
  };

  const [loadingLogin, setLoadingLogin] = useState(false);
  const [loadingVerifyCode, setLoadingVerifyCode] = useState(false);
  const [loadingRecovery, setLoadingRecovery] = useState(false);
  const SpinnerIcon = FaCircleNotch as unknown as React.FC<React.SVGProps<SVGSVGElement>>;
  const isOtpComplete = otpCode.every((digit) => digit.trim() !== '');

  return (
    <div className="login-container">
      <div className="login-page">
        <div className="login-column login-left">
          <div className="login-brand">
            <img src={logoAnga} alt="Logo Angá" className="logo-anga" />
            <p className="login-tagline">
              Gestão integrada.<br />
              Resultados <strong>conectados</strong>.
            </p>
          </div>
        </div>

        <div className="login-column login-right">
          <div className="login-form-wrapper">
            <img src={logoNexus} alt="Nexus" className="logo-nexus" />

            <form className="login-form" onSubmit={handleSubmit}>
              <label htmlFor="email">E-mail*</label>
              <input
                id="email"
                type="email"
                name="email"
                placeholder="seuemail@angaasset.com.br"
                value={formData.email}
                onChange={handleChange}
                className={emailError ? 'input-error' : ''}
                required
              />

              <label htmlFor="password">Senha*</label>
              <div className="password-field">
                <input
                  id="password"
                  type="password"
                  name="password"
                  placeholder="••••••••••"
                  value={formData.password}
                  onChange={handleChange}
                  className={passwordError ? 'input-error' : ''}
                  required
                />
              </div>

              <a onClick={() => setshowModalRecoveryPass(true)} className="forgot-password">Esqueci minha senha.</a>

              <button type="submit" className="login-button" disabled={loadingLogin}>
                {loadingLogin ? (
                  <>
                    <SpinnerIcon className="me-2 spinner-icon" />
                    Continuando...
                  </>
                ) : (
                  'Continuar'
                )}
              </button>
            </form>

            <p className="login-terms">
              Ao continuar, você concorda com os <a href="#">Termos de Serviço</a>
              <br />e a <a href="#">Política de Privacidade</a> do Nexus.
            </p>
          </div>
        </div>
      </div>

      {requireOtpCode && (
        <div className="modal-otp">
          <div className="modal-otp-content">
            <Modal.Header closeButton onClick={() => setRequireOtpCode(false)}></Modal.Header>
            <h3>Código de autenticação</h3>
            <form onSubmit={(e) => {
              e.preventDefault();
              handleVerifyCode();
            }}>
              {otpUri ? (
                <>
                  <p>Escaneie o QR Code abaixo com seu app de autenticação e informe os 6 dígitos.</p>
                  <div className="qr-container">
                    <QRCode value={otpUri} size={150} />
                  </div>
                </>
              ) : (
                <p>Informe os 6 dígitos do seu app de autenticação.</p>
              )}

              <div className="otp-inputs">
                {[...Array(6)].map((_, idx) => (
                  <input
                    key={idx}
                    ref={(el) => { otpRefs.current[idx] = el; }}
                    type="text"
                    maxLength={1}
                    value={otpCode[idx]}
                    onChange={(e) => {
                      const val = e.target.value.replace(/\D/g, '');
                      if (!val) return;

                      const newOtp = [...otpCode];
                      newOtp[idx] = val;
                      setOtpCode(newOtp);

                      if (idx < 5) otpRefs.current[idx + 1]?.focus();
                    }}
                    onKeyDown={(e) => {
                      if (e.key === 'Backspace') {
                        e.preventDefault();
                        const newOtp = [...otpCode];

                        if (otpCode[idx]) {
                          newOtp[idx] = '';
                          setOtpCode(newOtp);
                        } else if (idx > 0) {
                          newOtp[idx - 1] = '';
                          setOtpCode(newOtp);
                          otpRefs.current[idx - 1]?.focus();
                        }
                      }
                    }}
                    onPaste={(e) => {
                      e.preventDefault();
                      const paste = e.clipboardData.getData('text').replace(/\D/g, '').slice(0, 6);
                      const newOtp = [...otpCode];

                      for (let i = 0; i < paste.length; i++) {
                        newOtp[i] = paste[i];
                      }
                      setOtpCode(newOtp);
                      const nextIdx = paste.length < 6 ? paste.length : 5;
                      otpRefs.current[nextIdx]?.focus();
                    }}
                    style={{
                      width: '40px',
                      height: '40px',
                      textAlign: 'center',
                      fontSize: '20px',
                      marginRight: '8px',
                      borderRadius: '4px',
                      border: '1px solid #ccc',
                    }}
                  />
                ))}
              </div>

              <button type="submit" className="btn-verify" disabled={!isOtpComplete || loadingVerifyCode}>
                {loadingVerifyCode ? (
                  <>
                    <SpinnerIcon className="me-2 spinner-icon" />
                    Verificando...
                  </>
                ) : (
                  'Verificar conta'
                )}
              </button>

            </form>
          </div>

        </div>
      )}
      {toast.show && (
        <ToastNotification
          status={toast.status ?? 500}
          message={toast.message}
          onClose={() => setToast({ show: false, message: '' })}
        />
      )}


      <Modal show={showModalRecoveryPass} onHide={() => setshowModalRecoveryPass(false)} size="lg" centered dialogClassName="custom-modal" backdrop="static">
        <Modal.Header closeButton>
          <Modal.Title className="w-100 text-center text-primary fw-bold"></Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-4">
          <div className="text-center">
            <h5 className="text-primary fw-bold">Recuperando sua senha</h5>
            <div className="d-flex justify-content-center my-3">
              <div style={{ width: '60px', height: '4px', background: '#e0e0e0', borderRadius: '4px', marginLeft: '4px' }}></div>
            </div>
            <p className="fw-semibold mb-1">Digite o e-mail da sua conta</p>
            <p className="text-muted mb-4" style={{ fontSize: '0.9rem' }}>
              Para recuperar sua senha de acesso, digite o e-mail <br></br>para receber o link de redefinição.
            </p>
            <Form.Group className="mb-5" controlId="formEmail">
              <Form.Control
                type="email"
                placeholder="exemplo@e-mail.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="text-center"
                style={{ maxWidth: '400px', margin: '0 auto', padding: '0.5rem 0.75rem' }}
              />
            </Form.Group>
            <Button onClick={handleSend}>
              {loadingLogin ? (
                <>
                  <SpinnerIcon className="me-2 spinner-icon" />
                  Enviando...
                </>
              ) : (
                'Enviar'
              )}
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default Login;
